import { ButtonHTMLAttributes, DetailedHTMLProps, FunctionComponent, MouseEventHandler, ReactElement } from "react";
import styled from "styled-components";

import Icon from "types/Icon";

export interface IButtonProps
  extends Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, "children"> {
  id?: string;
  title?: string;
  icon?: ReactElement<Icon>;
  iconPosition?: "left" | "right";
  onClick?: MouseEventHandler;
  className?: string;
  disabled?: boolean;
  "data-testid"?: string;
}

const CustomButton = styled.button<{
  disabled: boolean;
}>`
  border: 1px solid;
  border-radius: 6px;

  width: fit-content;
  padding: 3px 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(22)};
  color: ${({ theme }) => theme.customTheme.palette.black.standard};
  font-family: ThemeFontRegular;

  background-color: ${({ theme, disabled }) => (disabled ? theme.customTheme.palette.grey.standard : "transparent")};

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  text-decoration: none;

  filter: brightness(100%);
  transition: filter 200ms ease;

  &:hover {
    filter: ${({ disabled }) => (disabled ? "brightness(100%)" : "brightness(150%)")};
  }
`;

const Button: FunctionComponent<IButtonProps> = ({
  id,
  title = "",
  icon,
  onClick,
  iconPosition = "left",
  disabled = false,
  ...props
}) => {
  return (
    <CustomButton data-testid={props?.["data-testid"] || id} id={id} onClick={onClick} disabled={disabled} {...props}>
      {icon && iconPosition === "left" && icon}
      {title}
      {icon && iconPosition === "right" && icon}
    </CustomButton>
  );
};

export default Button;
